// Generated file : do not modify
import { MetaValue } from '@/extend/classes/MetaAttrib';
import { GraphAnswer } from '@/extend/classes/GraphData';
import { GraphMinimum } from '@/extend/classes/GraphData';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Projet
export default class Projet  {
  // Identifiant unique
  public id: number;
  // Nom du projet
  public nom: string;
  // Numéro d'objet
  public numeroObjetId: number;
  // Etablissement
  public etablissementId: number;
  // Gestionnaire
  public userId: number;
  // 
  public etablissementNom: string;
  // Date début
  public dateDebut: Date;
  // Date fin
  public dateFin: Date | null;
  // Méta-attributs
  public metaValues: MetaValue[];
  // Graph answers
  public graphAnswers: GraphAnswer[];
  // Graph minimum
  public graphMinimum: GraphMinimum;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Client
  public clientId: number;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.nom = '';
    this.numeroObjetId = 0;
    this.etablissementId = 0;
    this.userId = 0;
    this.etablissementNom = '';
    this.dateDebut = new Date(1901,1,1,0,0,0,0);
    this.dateFin = null;
    this.metaValues = [];
    this.graphAnswers = [];
    this.graphMinimum = new GraphMinimum();
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.clientId = 0;
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Projet): Projet {
    const newProjet: Projet = new Projet();
    newProjet.id = obj.id;
    newProjet.nom = obj.nom;
    newProjet.numeroObjetId = obj.numeroObjetId;
    newProjet.etablissementId = obj.etablissementId;
    newProjet.userId = obj.userId;
    newProjet.etablissementNom = obj.etablissementNom;
    newProjet.dateDebut = new Date(obj.dateDebut);
    newProjet.dateFin = obj.dateFin ? new Date(obj.dateFin) : null;
    newProjet.metaValues = JSON.parse(JSON.stringify(obj.metaValues));
    newProjet.graphAnswers = JSON.parse(JSON.stringify(obj.graphAnswers));
    newProjet.graphMinimum = JSON.parse(JSON.stringify(obj.graphMinimum));
    newProjet.createId = obj.createId;
    newProjet.failed = obj.failed;
    newProjet.canUpdate = obj.canUpdate;
    newProjet.canDelete = obj.canDelete;
    newProjet.display = obj.display;
    newProjet.clientId = obj.clientId;
    newProjet.notifDefType = obj.notifDefType;
    return newProjet;
  }

  public toJsonProjet (): string {
    const json = {
      nom: this.nom,
      numeroObjetId: this.numeroObjetId,
      etablissementId: this.etablissementId,
      userId: this.userId,
      etablissementNom: this.etablissementNom,
      dateDebut: this.dateDebut ? new Date (this.dateDebut).toString() : this.dateDebut,
      dateFin: this.dateFin ? new Date (this.dateFin).toString() : this.dateFin,
      metaValues: this.metaValues,
      graphAnswers: this.graphAnswers,
      graphMinimum: this.graphMinimum,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromProjet (obj: Projet): void {
    this.id = obj.id;
    this.nom = obj.nom;
    this.numeroObjetId = obj.numeroObjetId;
    this.etablissementId = obj.etablissementId;
    this.userId = obj.userId;
    this.etablissementNom = obj.etablissementNom;
    this.dateDebut = new Date(obj.dateDebut);
    this.dateFin = obj.dateFin;
    this.metaValues = obj.metaValues;
    this.graphAnswers = obj.graphAnswers;
    this.graphMinimum = obj.graphMinimum;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.clientId = obj.clientId;
    this.notifDefType = obj.notifDefType;
  }

  public compareProjet (value: Projet): boolean {
    return (this.toJsonProjet() == value.toJsonProjet());
  }

  public cloneProjet (): Projet {
    return Projet.fromJson(this);
  }

  public createForStoreProjet (): Promise<Projet> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/projets/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromProjet(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreProjet (): Promise<Projet> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/projets/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromProjet(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreProjet (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/projets/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/projets/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Projets/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Projet.fromJson(listData.reccords[0] as Projet);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Projet> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Projets/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Projet.fromJson(listData.reccords[0] as Projet);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(projets: Projet[]) {
    projets.forEach((item) => {
      item.dateDebut = item.dateDebut ? new Date(item.dateDebut) : item.dateDebut;
      item.dateFin = item.dateFin ? new Date(item.dateFin) : item.dateFin;
    })
  }
}
